import { Heading } from '@flixbus/honeycomb-react';

import { CREW_MEMBER_SEARCH_TEXT } from './text';

import styles from './styles.module.css';

const CrewMemberSearchOption = ({ option }) => {
	const { title, driverCard, status } = option;
	const isInactive = status === 'inactive';

	return (
		<Heading Elem="span" size={4} extraClasses={styles.option} flushSpace sectionHeader>
			<div className={styles.optionTitle}>
				<span>{title}</span>
				{isInactive && <span className={styles.inactive}>{CREW_MEMBER_SEARCH_TEXT.inactive}</span>}
			</div>
			{driverCard && (
				<div className={styles.driverCard}>
					{CREW_MEMBER_SEARCH_TEXT.id}: {driverCard}
				</div>
			)}
		</Heading>
	);
};

export default CrewMemberSearchOption;
